<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <Heading title="Help & Support" subTitle="Be it any question, related to Superchargify, or just Shopify in general, we are here to help you!" />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Live Chat</h2>
        <p class="font-weight-normal mb-0">Talk to a human.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <p class="font-weight-normal">Live support is available from <a rel="noopener" target="_blank" href="https://www.worldtimebuddy.com/?qm=1&lid=30,100,5,8&h=30&sln=11-18">5.30am to 12.30pm UTC</a>.</p>

              <Alert class="alert-danger mb-0" v-if="noFc" title="Oh snap!" icon="IconImportant">
                <p class="mb-1">Our live chat widget couldn't load properly because of an Ad Blocker or an extention installed in your browser.</p>
                <p class="mb-0">Please disable your Ad Blocker and refresh this page to use Live chat.</p>
              </Alert>
              <button class="btn btn-primary" @click="toggleChat" v-else>Open Live Chat</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Help Desk</h2>
        <p class="font-weight-normal mb-0">Submit a ticket.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <a class="btn btn-primary" href="https://superchargify.freshdesk.com/support/home" target="_blank" rel="noopener">Visit Help Desk <IconExternalWindow class="ml-1 match-icon-color" height="18" style="vertical-align: text-bottom" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Email</h2>
        <p class="font-weight-normal mb-0">Send us an email!</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <a href="mailto:support@superchargify.com">support@superchargify.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="mt-5 mb-5" />

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Review</h2>
        <p class="font-weight-normal mb-0">Let us know how we're doing!</p>
      </div>
      <div class="col-md-8">
        <LeaveReview />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import LeaveReview from '@/components/LeaveReview'

export default {
  components: {
    LeaveReview
  },
  computed: mapState([ 'shopObj' ]),
  data: function () {
    return {
      noFc: false
    }
  },
  mounted: function () {
    if (window.fcWidget && typeof window.fcWidget.open === 'function') {
      // cool
    } else {
      this.noFc = true
    }
  },
  methods: {
    toggleChat: function () {
      try {
        if (!window.fcWidget.isOpen()) {
          window.fcWidget.open()
        }
      } catch (e) {
        this.noFc = true
      }
    }
  }
}
</script>
